export default "__VITE_ASSET__90kP3CFa__"